import script from "./TgSessionCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./TgSessionCard.vue?vue&type=script&lang=ts&setup=true"

import "./TgSessionCard.vue?vue&type=style&index=0&id=1b691060&scoped=true&lang=css"
import "./TgSessionCard.vue?vue&type=style&index=1&id=1b691060&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b691060"]])

export default __exports__